import { useState } from 'react';

const useCustomHook = () => {
  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  return {
    isLoading,
    setIsLoading,
    list,
    setList,
  };
};

export default useCustomHook;
